import React from 'react'

const Banner = () => {
  return (
    <div>
       <div className="footer-wrapper-bg">
        <div className="bg-image">
          <h1 id="footer-bg-head">
            Your <span className="hobby">Hobby</span>, Your{" "}
            <span className="passion">Community</span>
          </h1>
          <a href="#" className="btn btn-primary bg-purple">
            Get started
          </a>
        </div>
      </div>
    </div>
  )
}

export default Banner
